var Heros = {
    init: function(target) {
        
       
        $('.scroll-down').click(function(e){
          $("html, body").animate({ scrollTop: $(target).innerHeight() }, 500); 
          e.preventDefault();
        });
    
    }
}